module.exports = __webpack_public_path__ + "593a3d53/img/pwrd-by-sourcery-black.bba9ba41.svg";